module.exports = __webpack_public_path__ + "static/media/36.35549975.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/36.jpg
// module id = 296
// module chunks = 0